import { createApp } from 'vue'
import App from '@/App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createPinia } from 'pinia'
import router from '@/router/main-router'
import apm from './config/apm'
import moment from 'moment';
import VueGtag from "vue-gtag";
// import '@/index.css'
import util from '@/assets/js/util.js'

//-- axios
import axios from 'axios'
import VueAxios from 'vue-axios'

//-- vue-cookies
import VueCookies from 'vue3-cookies'
import Vue3Tour from 'vue3-tour'

import 'vue3-tour/dist/vue3-tour.css'
// -- Firebase
import { analytics } from './client/firebase';

loadFonts()

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(VueGtag, {
    pageTrackerExcludedRoutes: [
        '/reportsearch',
        '/healthcheck',
        '/dashboard',
        '/profile'
    ],
    config: {
        id: process.env.GOOGLE_ANALYTICS_ID,
    },
}, router)
app.use(vuetify)
app.use(Vue3Tour)
app.use(apm)

app.use(VueCookies, {
    expireTimes: "7d",
    path: process.env.VUE_APP_COOKIE_PATH,
    domain: process.env.VUE_APP_COOKIE_HOST,
    secure: process.env.VUE_APP_COOKIE_SECURE || false
})


//-- auth
import insting from '@/assets/js/insting';
import { authStore } from '@/stores/auth.js'

import { layoutStore } from '@/stores/layout.js'
import vue3Tour from 'vue3-tour'

const layout = layoutStore()

//-- prepare axios setting and loading it into vue
const api_url = process.env.VUE_APP_ESB
const api_url_ugems = process.env.VUE_APP_UGEMS_URL
const api_url_insting = process.env.VUE_APP_INSTING
const api_url_elastic = process.env.VUE_APP_ELASTIC_SEARCH
const apiAxiosCustom = axios.create({

})
const apiAxios = axios.create({
    baseURL: api_url
})
const apiAxiosUgems = axios.create({
    baseURL: api_url_ugems
})
const apiAxiosElastic = axios.create({
    baseURL: api_url_elastic
})
const apiAxiosInsting = axios.create({
    baseURL: api_url_insting
})

apiAxios.interceptors.request.use(function (cfg) {
    layout.setLoading(true)

    // Cannot set properties of undefined (setting 'Authorization')
    const auth = authStore()
    if (auth.appTokenInsting != '') {
        cfg.headers['Authorization'] = 'Bearer ' + auth.appTokenInsting;
        cfg.headers['Authorization-ESB'] = auth.appToken;
    }
    cfg.metadata = { startTime: new Date(), endTime: new Date(), duration: 0 }
    return cfg
})
apiAxios.interceptors.response.use(r => {
    layout.setLoading(false)
    if (r.data && r.data.error) {
        const errorMessage = r.data.error
        if (errorMessage == "EOF") {
            return Promise.reject("Sorry, but the data you looking for is not exist")
        } else if (errorMessage.indexOf("invalid access token") > 0 || errorMessage.indexOf("invalid token") > 0) {
            util.clearCookies();
        }
        return Promise.reject(errorMessage)
    }
    r.config.metadata.endTime = new Date()
    r.config.metadata.duration = ((r.config.metadata.endTime - r.config.metadata.startTime) / 60 / 60).toFixed(2);
    return Promise.resolve(r)
}, e => {
    layout.setLoading(false)
    e.config.metadata.endTime = new Date();
    e.config.metadata.duration = ((e.config.metadata.endTime - e.config.metadata.startTime) / 60 / 60).toFixed(2);
    if (e.status == 401) {
        util.clearCookies();
        router.push("/login");
        localStorage.clear();
    }
    return Promise.reject(e)
})

// axios ugems
apiAxiosUgems.interceptors.request.use(function (cfg) {
    layout.setLoading(true)

    // Cannot set properties of undefined (setting 'Authorization')
    const auth = authStore()
    if (auth.appTokenUgems != '') {
        cfg.headers['Authorization'] = 'Bearer ' + auth.appTokenUgems
    }
    cfg.metadata = { startTime: new Date(), endTime: new Date(), duration: 0 }
    return cfg
})
apiAxiosUgems.interceptors.response.use(r => {
    const auth = authStore()
    layout.setLoading(false)
    if (r.data && r.data.error) {
        const errorMessage = r.data.error
        if (errorMessage == "EOF") {
            return Promise.reject("Sorry, but the data you looking for is not exist")
        } else if (errorMessage.indexOf("invalid access token") > 0 || errorMessage.indexOf("invalid token") > 0) {
            // auth.clear()
        }
        return Promise.reject(errorMessage)
    }
    r.config.metadata.endTime = new Date()
    r.config.metadata.duration = ((r.config.metadata.endTime - r.config.metadata.startTime) / 60 / 60).toFixed(2);
    return Promise.resolve(r)
}, e => {
    layout.setLoading(false)
    e.config.metadata.endTime = new Date();
    e.config.metadata.duration = ((e.config.metadata.endTime - e.config.metadata.startTime) / 60 / 60).toFixed(2);
    return Promise.reject(e)
})

// axios insting
apiAxiosInsting.interceptors.request.use(function (cfg) {
    layout.setLoading(true)

    // Cannot set properties of undefined (setting 'Authorization')
    const auth = authStore()
    if (auth.appTokenInsting != '') {
        cfg.headers['Authorization'] = 'Bearer ' + auth.appTokenInsting
    }
    cfg.metadata = { startTime: new Date(), endTime: new Date(), duration: 0 }
    return cfg
})
apiAxiosInsting.interceptors.response.use(r => {
    const auth = authStore()
    layout.setLoading(false)
    if (r.data && r.data.error) {
        const errorMessage = r.data.error
        if (errorMessage == "EOF") {
            return Promise.reject("Sorry, but the data you looking for is not exist")
        } else if (errorMessage.indexOf("invalid access token") > 0 || errorMessage.indexOf("invalid token") > 0) {
            router.push("/login");
            util.clearCookies();
            localStorage.clear();
        }
        return Promise.reject(errorMessage)
    }
    r.config.metadata.endTime = new Date()
    r.config.metadata.duration = ((r.config.metadata.endTime - r.config.metadata.startTime) / 60 / 60).toFixed(2);
    return Promise.resolve(r)
}, e => {
    const auth = authStore()
    layout.setLoading(false)
    e.config.metadata.endTime = new Date();
    e.config.metadata.duration = ((e.config.metadata.endTime - e.config.metadata.startTime) / 60 / 60).toFixed(2);
    if (e.response.status == 401) {
        router.push("/login");
        util.clearCookies();
        localStorage.clear();
    }
    return Promise.reject(e)
})

// TODO ELASTIC: Adjustment
apiAxiosElastic.interceptors.response.use(r => {
    const auth = authStore()
    layout.setLoading(false)
    if (r.data && r.data.error) {
        const errorMessage = r.data.error
        if (errorMessage == "EOF") {
            return Promise.reject("Sorry, but the data you looking for is not exist")
        } else if (errorMessage.indexOf("invalid access token") > 0 || errorMessage.indexOf("invalid token") > 0) {
            auth.clear()
        }
        return Promise.reject(errorMessage)
    }
    // r.config.metadata.endTime = new Date()
    // r.config.metadata.duration = ((r.config.metadata.endTime - r.config.metadata.startTime) / 60 / 60).toFixed(2);
    return Promise.resolve(r)
}, e => {
    const auth = authStore()
    layout.setLoading(false)
    e.config.metadata.endTime = new Date();
    e.config.metadata.duration = ((e.config.metadata.endTime - e.config.metadata.startTime) / 60 / 60).toFixed(2);
    if (e.response.status == 401) {
        router.push("/login");
        auth.clear();
        localStorage.clear();
    }
    return Promise.reject(e)
})

// Create the mixin for global use
const momentMixin = {
    methods: {
        formatDate(value, format = 'DD MMM YYYY') {
            if (value) {
                return moment(value).utcOffset('+08:00').format(format);
            }
            return '';
        },
        formatTime(value, format = 'hh:mm A') {
            if (value) {
                return moment(value).utcOffset('+08:00').format(format);
            }
            return '';
        },
        formatDateTime(value, format = 'DD MMM YYYY hh:ss A') {
            if (value) {
                return moment(value).utcOffset('+08:00').format(format);
            }
            return '';
        },
        formatDateTime24(value, format = 'DD MMM YYYY HH:mm') {
            if (value) {
                return moment(value).utcOffset('+08:00').format(format);
            }
            return '';
        },
        formatDateTime24TimeShift(value) {
            if (value) {
                // Dynamic default filter based on current time
                const now = moment().utcOffset(8); // Current time in WITA (UTC+8)
                const currentHour = now.hour(); // Get the current hour in WITA

                let startDate;

                if (process.env.VUE_APP_SEARCH_UGEMS === "false") {
                    if (currentHour >= 6 && currentHour < 18) {
                        // Day Shift: 06:00 - 18:00 in WITA
                        startDate = moment().utcOffset(8).startOf('day').add(6, 'hours').utc().format('YYYY-MM-DD HH:mm'); // Today 06:00 in UTC
                    } else {
                        // Night Shift: 18:00 - 06:00 in WITA
                        if (currentHour < 6) {
                            // If it's after midnight but before 06:00 in WITA
                            startDate = moment().utcOffset(8).subtract(1, 'days').startOf('day').add(18, 'hours').utc().format('YYYY-MM-DD HH:mm'); // Yesterday 18:00 in UTC
                        } else {
                            // If it's after 18:00 in WITA
                            startDate = moment().utcOffset(8).startOf('day').add(18, 'hours').utc().format('YYYY-MM-DD HH:mm'); // Today 18:00 in UTC
                        }
                    }
                }

                return startDate;
            }
            return '';
        }
    }
};

app.mixin(momentMixin);
app.use(VueAxios, axios)
app.provide('axiosCustom', apiAxiosCustom)
app.provide('axios', apiAxios)
app.provide('axiosUgems', apiAxiosUgems)
app.provide('axiosElastic', apiAxiosElastic)
app.provide('axiosInsting', apiAxiosInsting)

app.config.globalProperties.$analytics = analytics;

app.mount('#app')